export const usePDPConfig = () => ({
    isBazaarVoiceEnabled: Sephora.configurationSettings?.isBazaarVoiceEnabled ?? false,
    isCommunityServiceEnabled: Sephora.configurationSettings?.isCommunityServiceEnabled ?? false,
    pdpSamples: Sephora.configurationSettings?.pdpSamples ?? null
});
